export default "__VITE_ASSET__B$I2oHtV__";